// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NtNR","rightAdornment":"Header_rightAdornment__3AUEO"};